import axios from 'axios';
export default {
    async createOrder(cartId: string) {
        const response = await axios.get('/api/cart/v1/cart/order/' + cartId);
        console.log(response);
        return response.data;
    },
}